var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EventsInside',{attrs:{"eventItems":_vm.eventItems,"listReady":_vm.listReady,"tags":_vm.tags}})}
var staticRenderFns = []

export { render, staticRenderFns }